// extracted by mini-css-extract-plugin
export default {"button":"m022zm","link":"aUkG34","linkText":"kaP5hc","fullWidth":"a2w9Ux"};